export default (tournamentData, pageData) => {

  const t = {}
  t.data = {
    tournament: tournamentData,
    page: pageData
  }
  const init = () => {
    console.log('buildTournament', t.data);
    t.root = document.querySelector('.le-tournament');

    buildTournament();
    // buildDrum();

    t.root.classList.remove('_skelton');
    t.root.removeAttribute('aria-hidden');
  }

  const buildTournament = () => {
    const tourList = t.root.querySelector('.le-tournament__list');
    const tourListItem = tourList.firstElementChild;

    const fragmentElement = document.createDocumentFragment();

    [
      {
        slug: 'player',
        txt: '出場選手'
      },
      {
        slug: 'timetrial',
        txt: 'タイムトライアル'
      }
    ].forEach(raceInfo => {
      const cloneListItemPreRaceInfo = convertPreRaceInfoListItem(tourListItem.cloneNode(true), raceInfo);
      fragmentElement.appendChild(cloneListItemPreRaceInfo);
    })

    t.data.tournament.forEach(tourInfoObj => {
      const cloneListItem = convertRaceInfoListitem(tourListItem.cloneNode(true), tourInfoObj);
      fragmentElement.appendChild(cloneListItem);
    });

    tourList.innerHTML = '';
    tourList.appendChild(fragmentElement);
  }

  const convertPreRaceInfoListItem = (cloneNode, preRaceInfo) => {
    if (preRaceInfo.slug == t.data.page.tournament) {
      cloneNode.classList.add('is-current');
    }

    const txt = cloneNode.querySelector('.le-tournament__link-txt');
    if (preRaceInfo.slug == 'timetrial' && !t.data.page.hasTtResult) {
      const disabledLink = document.createElement('div');
      disabledLink.classList.add('le-tournament__link', '_disabled');
      disabledLink.appendChild(txt);
      cloneNode.innerHTML = '';
      cloneNode.appendChild(disabledLink);
    } else {
      const link = cloneNode.querySelector('.le-tournament__link');
      link.href = `/league/${preRaceInfo.slug}/?year=${t.data.page.year}&season=${t.data.page.season}&round_code=${t.data.page.roundCode}`;
    }

    txt.innerHTML = `<span class="le-tournament__link-name">${preRaceInfo.txt}</span>`;

    return cloneNode;
  }
  const convertRaceInfoListitem = (cloneNode, raceInfo) => {
    if (raceInfo.isCurrent) {
      cloneNode.classList.add('is-current');
    }

    const link = cloneNode.querySelector('.le-tournament__link');
    const pageInfo = getTournamentClassification(raceInfo.event_code);

    // 開催の可否によって要素の入れ替え処理
    if (raceInfo.isTournamentDiscontinuation) {
      const linkWrapElement = link.parentElement;
      linkWrapElement.innerHTML = `<div class="le-tournament__link _disabled">${link.innerHTML}</div>`;
    } else {
      link.href = `/league/${pageInfo.path}/?year=${t.data.page.year}&season=${t.data.page.season}&round_code=${t.data.page.roundCode}&event_code=${raceInfo.event_code}`;
    }

    const txt = cloneNode.querySelector('.le-tournament__link-txt');
    txt.innerHTML = `<span class="le-tournament__link-name">${pageInfo.txt}</span><span class="le-tournament__link-date">${raceInfo.date}</span>`;

    return cloneNode
  }

  // サイドバー用区分コード取得
  const getRaceCode = (eventCode = 'U') => {
    if (eventCode.toLowerCase() == 'u') {
      return 'U'; // 1次予選
    } else if (['v'].includes(eventCode.toLowerCase())) {
      return 'V'; // 2次予選
    } else if (['2', 'r'].includes(eventCode.toLowerCase())) {
      return '2'; // 準決勝
    } else if (['3', 't'].includes(eventCode.toLowerCase())) {
      return '3'; // 決勝
    } else {
      return eventCode;
    }
  }
  const getTournamentClassification = (eventCode) => {
    const tournamentMap = {
      "U": {
        txt: '1次予選',
        classification: 'qualifying',
        path: 'qualifying'
      },
      'V': {
        txt: '2次予選',
        classification: 'qualifying',
        path: 'qualifying2'
      },
      '2': {
        txt: '準決勝',
        classification: 'semifinal',
        path: 'semifinal'
      },
      'R': {
        txt: '準決勝',
        classification: 'semifinal',
        path: 'semifinal'
      },
      '3': {
        txt: '決勝',
        classification: 'final',
        path: 'final'
      },
      'T': {
        txt: '決勝',
        classification: 'final',
        path: 'final'
      }
    }
    // eventCode が順位戦で帰ってくる場合があるので、
    // ページに対応した文字列オブジェクトを返すようにする
    //   R: 順位戦
    //   T: 順位決定戦

    return tournamentMap[getRaceCode(eventCode)]
      ? tournamentMap[getRaceCode(eventCode)]
      : {
        txt: '1次予選',
        path: 'qualifying'
      }; // 上記はデータが返ってこなかったときのための暫定処理
  }

  init();
}
